import { useState, useRef } from 'react';
import styled from 'styled-components';

import DaumPostcode from 'react-daum-postcode';
import DefaultInput from 'components/input/DefaultInput';
import DefaultButton from 'components/button/DefaultButton';

import { font } from 'asserts/styles/fonts';
import { color } from 'asserts/styles/colors';
import ic_arrow_left from 'asserts/icons/ic_arrow_left.svg';
import ic_x from 'asserts/icons/ic_x.svg';

interface Props {
  onClickClose: () => void;
  onChange: (arg: React.FormEvent<HTMLInputElement> | { [key: string]: string }) => void;
}

export default function AddressModal({ onClickClose, onChange }: Props) {
  const addreddRef: React.RefObject<HTMLDivElement> = useRef(null);
  const [data, setData] = useState({
    address: '',
    zonecode: ''
  });
  const [detail, setDetail] = useState('');

  const onComplete = (data: any) => {
    setData({
      address: data.address,
      zonecode: data.zonecode
    });
  };

  const onClickBack = () => {
    setDetail('');
    setData({
      address: '',
      zonecode: ''
    });
  };

  const onSubmit = () => {
    onChange({
      zipcode: data.zonecode,
      address: `${data.address} ${detail}`
    });
    onClickClose();
  };

  const onClickBackground = (e: any) => {
    if (addreddRef.current && !addreddRef.current.contains(e.target)) {
      onClickClose();
    }
  };

  return (
    <Modal onClick={onClickBackground}>
      <Address ref={addreddRef}>
        <Header>
          {data.address !== '' && data.zonecode !== '' && (
            <img
              src={ic_arrow_left}
              style={{ width: '20px', height: '20px' }}
              onClick={onClickBack}
              alt="뒤로가기 아이콘"
            />
          )}
          <img
            src={ic_x}
            style={{ marginLeft: 'auto' }}
            onClick={onClickClose}
            alt="모달 종료 아이콘"
          />
        </Header>
        <Title>
          {data.address !== '' && data.zonecode !== ''
            ? '상세주소를 알려주세요.'
            : '주소를 검색해주세요.'}
        </Title>
        {data.address !== '' && data.zonecode !== '' ? (
          <DetailContainer>
            <AddressArea>
              <AddressTitle>주소</AddressTitle>({data.zonecode}) {data.address}
            </AddressArea>
            <DefaultInput
              name="detail"
              value={detail}
              onChange={(e: any) => setDetail(e.target.value)}
              placeholder="상세주소를 입력해주세요."
              size="large"
            />
            <DefaultButton text="확인" size="middle" type="primary" onClick={onSubmit} />
          </DetailContainer>
        ) : (
          <DaumPostcode
            style={{
              height: 'calc(100% - 80px)'
            }}
            onComplete={onComplete} // 값을 선택할 경우 실행되는 이벤트
            autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정
          />
        )}
      </Address>
    </Modal>
  );
}

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.2);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  img {
    cursor: pointer;
  }
`;

const Address = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 600px;
  height: 700px;
  margin: 0 auto;
  background-color: ${color.white};
  padding: 32px;
  border-radius: 16px;
`;

const Title = styled.p`
  ${font.h3_bold};
  margin-bottom: 16px;
`;

const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  button {
    width: 100%;
  }
`;

const AddressArea = styled.div`
  ${font.body_regular};
  color: ${color.gray700};
`;

const AddressTitle = styled.p`
  ${font.body_light};
  margin-bottom: 8px;
  color: ${color.gray400};
`;
